<template>
    <div class="checkInBox flexCol">
        <div class="campusBox rowAc" @click="showPicker = true">
            <div>{{campus}}</div>
            <div :class="[showPicker?'icon-arrow-up':'icon-arrow-down']"></div>
        </div>
        <van-popup v-model="showPicker" round position="bottom">
            <van-picker
                show-toolbar
                ref="selectCampus"
                :columns="campusNames"
                :default-index="campusIdx"
                @cancel="showPicker=false"
                @confirm="selectCampusConfirm"
            />
        </van-popup>
        <div class="calendarBox rowJbAc" @click="show = true">
            <div class="text rowAc">
                <div class="icon-calendar"></div>
                <div>请选择日期</div>
            </div>
            <div class="icon-arrow-left arrowIcon" v-if="!dateRangeText"></div>
            <div class="date" v-else>{{dateRangeText}}</div>
        </div>
        <van-calendar v-model="show" @closed="closedCalendar" ref="calendar"  type="range" :min-date="minDate" :default-date="defaultDate" @confirm="onConfirm" color="#6985FF"/>
        <div class="list">
            <div class="emptyBox colAc" v-if="list.length == 0">
                <img src="../../assets/static/emptyList.png" alt="">
                <div>暂时还没有活动哦</div>
            </div>
            <van-list
            v-else
            v-model="loading"
            :finished="finished"
            finished-text="没有更多了"
            @load="onLoad"
            > 
                    <van-cell v-for="(item,index) in list" :key="index" @click="goStudents(item)">
                        <div class="item">
                            <div class="line" :class="status[item.status].bgc"></div>
                            <div class="courseInfo">
                                <div class="courseName textOver">{{item.name}}</div>
                                <div class="courseDetail rowAc">
                                    <div class="title">活动类型：</div>
                                    <div>{{types[item.type]}}</div>
                                </div>
                                <div class="courseDetail rowAc">
                                    <div class="title">负责老师：</div>
                                    <div> {{item.teacherName}}</div>
                                </div>
                                <div class="courseDetail rowAc">
                                    <div class="title">老师电话：</div>
                                    <div>{{item.teacherPhone}}</div>
                                </div>
                                <div class="courseDetail rowAc">
                                    <div class="title">活动时间：</div>
                                    <div>{{item.startTime}}</div>
                                </div>
                                <div class="courseDetail rowAs">
                                    <div class="title">活动地点：</div>
                                    <div>{{item.address}}</div>
                                </div>
                                <div class="courseDetail rowAs">
                                    <div class="title">助教老师：</div>
                                    <div>{{item.assistantTeachers}}</div>
                                </div>
                                <div class="courseDetail rowAc">
                                    <div class="title">收取费用：</div>
                                    <div class="">{{item.cost}}</div>
                                </div>
                                <div class="courseDetail rowAc">
                                    <div class="title">参与人数：</div>
                                    <div>{{item.joinStudents}}</div>
                                </div>
                            </div>
                            <div class="statusBox rowJcAc" :class="status[item.status].bgc">{{status[item.status].text}}</div>
                        </div>
                    </van-cell>
                </van-list>
        </div>
    </div>
</template>
<script>
import {getActivityListAPI,getInstitutionCampusAPI,getAuthsRefreshAPI} from '../../utils/api/api'
export default {
    data() {
        return {
            total: 0,// 总条数
            current: 1,
            pageSize: 10,
            dateRange: ['',''],
            defaultDate: [new Date(),new Date()],
            minDate: new Date(2016, 0, 1),
            campus: '',
            campusCode: '',
            parentUid: '',
            showPicker: false,
            campusNames: [],
            campusList: [],
            show: false,
            types: {
                1: '课外活动', 
                2:'汇报演出',
                3: '专业考级', 
            },
            status: {
                0: {bgc: "start",text: '未开始'}, 
                1: {bgc: "finish",text: '已完成'},
                2: {bgc: "cancle",text: '已取消'}, 
            },
            list: [
                // {
                //     name:'小红',
                //     teacherName:'大红老师',
                //     teacherPhone:'13546879686',
                //     startTime:'2020-02-02',
                //     address:'天安云谷',
                //     assistantTeachers:"大明老师",
                //     cost:'33',
                //     joinStudents:'34',
                //     status:1

                // }
            ],
            loading: false,
            finished: false,
            currPage:1
        }
    },
    computed: {
        // 选中校区的id
        campusIdx() {
           return this.campusNames.findIndex(item => {return item == this.campus})
        },
        dateRangeText() {
            if(this.dateRange && this.dateRange[0] && this.dateRange[1]) {
                return this.dateRange[0]+' 至 '+this.dateRange[1]
            }else {
                return false
            }
        },
    },
    watch: {
        // 取消选中 校区时选中索引改为当前选中
        showPicker() {
            if(!this.showPicker) {
                this.$refs.selectCampus.setIndexes([this.campusIdx])
            }
        }
    },
    created() {
        if(this.$common.getCache('institutionCode')) {
            this.campusNames = []
            var institutionCode = this.$common.getCache('institutionCode')
            
            getInstitutionCampusAPI({code: institutionCode}).then(res => {
                console.log('校区列表：',res)
                if(res.resultCode == 200 && res.data) {
                    res.data.forEach(item => {
                        this.campusNames.push(item.name)
                        if(this.$common.getCache('campusCode')) {
                            if(item.code == this.$common.getCache('campusCode')) {
                                this.campus = item.name
                                this.campusCode = item.code
                            }
                        }
                        this.campusList.push({
                            campusName: item.name,
                            campusCode: item.code
                        })
                    })
                    
                }
            })
        }
    },
    // 进入学生列表页面时缓存当前页面
    beforeRouteLeave(to,from,next) {
        if(to.path == '/students') {
            from.meta.keepAlive = true
            next()
        }else {
            from.meta.keepAlive = false
            next()
        }
    },
    methods: {
        //跳转到活动学员页面
        goStudents(item){
            this.$router.push({
                name: "Students",
                params: {  activitiesId: item.id },
            });
        },
         onLoad() {
        // 异步更新数据
        if(this.dateRangeText){
             setTimeout(() => {
                this.current++
                this.getList()
        }, 500);
        }else{
            this.loading = false;
        }  
        },
        // 改变日期格式
        formatDate(date) {
            return `${date.getFullYear()}-${this.changeNum(date.getMonth() + 1)}-${this.changeNum(date.getDate())}`;
        },
        // 日期选中点击确认
        onConfirm(date) {
            this.current = 1
            this.total = 0
            this.dateRange = []
            this.list = []
            const [start, end] = date;
            this.defaultDate = [start,end]
            this.show = false;
            this.dateRange.push(this.formatDate(start))
            this.dateRange.push(this.formatDate(end))
            this.getList()
        },
        changeNum(num) {
            if(num < 10) {
                return '0'+num
            }else {
                return num
            }
        },
        // 选择校区确认
        async selectCampusConfirm(value) {
            this.showPicker = false;
             if(this.campus == value) {
                return
            }
            this.campus = value;
            this.campusCode = this.campusList[this.campusIdx].campusCode
            var res = await getAuthsRefreshAPI({campusCode:this.campusCode})
            if(res.resultCode == 200) {
                // localStorage.setItem('campusCode',res.data.campusCode)
                // localStorage.setItem('institutionCode',res.data.institutionCode)
                // localStorage.setItem('token',res.data.token)
                this.$common.setCache('campusCode',res.data.campusCode)
                this.$common.setCache('institutionCode',res.data.institutionCode)
                this.$common.setCache('token',res.data.token)
            }
            this.current = 1
            this.list = []
            this.getList()
        },
        // 日历弹框消失，重新设置默认选中日期
        closedCalendar() {
            this.$refs.calendar.reset()
        },
        // 获取列表
        getList() {
            var obj = {
                campusCode: this.campusCode,
                currPage: this.current,
                pageSize: this.pageSize
            }
            if(this.dateRange && this.dateRange[0] && this.dateRange[1]) {
                obj['startDate'] = this.dateRange[0]
                obj['endDate'] = this.dateRange[1]
            }
            getActivityListAPI(obj).then(res => {
                console.log('活动列表：',res)
                if(res.resultCode == 200) {
                    this.loading = false;
                    this.total = res.data.totalCount
                    if(res.data.dataList) {
                        res.data.dataList.forEach(item => {
                            this.list.push(item)
                        })
                    }
                    
                    if(this.list.length == res.data.totalCount) {
                        this.finished = true;
                        return
                    }else {
                        this.finished = false;
                    }

                }
            })
        }
    }
}
</script>
<style lang="scss" scoped>
.start {
    background-color: #24C588;
}
.finish {
    background-color: #40A9FF;
}
.cancle {
    background-color: #9EA8BA;
}
.checkInBox {
    width: 100%;
    height: 100%;
    background: #F4FAFF;
    padding: 12px 0 12px .15rem;
    box-sizing: border-box;
    overflow: auto;
}
.campusBox {
    margin-right: .15rem;
    font-size: 16px;
    color: #333843;
    font-weight: 500;
    line-height: 23px;
}
.icon {
    margin-left: 4px;
}
.courseInfo {
    padding: 16px 0;
}
.courseName {
    font-size: 16px;
    color: #333843;
    line-height: 23px;
    padding-bottom: 8px;
}
.courseDetail {
    color: #666;
    font-size: 12px;
    line-height: 17px;
    margin-top: 4px;
}
.title{
    min-width: 60px;
}
.calendarBox {
    margin-right: .15rem;
    padding: 0 10px 0 12px;
    height: 32px;
    background: #FEFFFE;
    border-radius: 16px;
    margin-top: 18px;
    margin-bottom: 8px;
    color: #333843;
    line-height: 32px;
    .text {
        >div:first-child {
            margin-right: 4px;
        }
        font-size: 14px;
    }
    .arrowIcon {
        font-size: 16px;
        color: #9EA8BA;
    }
    .date {
        font-size: 14px;
        color: #6985FF;
    }
}
.list {
    padding-right: .15rem;
    flex: 1;
    overflow: auto;
    box-sizing: border-box;
}
.item {
    position: relative;
    margin-top: 12px;
    padding-left: 24px;
    min-height: 227px;
    background: #FFFFFF;
    box-shadow: 0px 2px 6px 0px rgba(12,12,13,0.1);
    border-radius: 6px;
}
.line {
    position: absolute;
    top: 0px;
    left: 0px;
    width: 6px;
    height: 100%;
    border-radius: 6px 0px 0px 6px;
}
.statusBox {
    position: absolute;
    top: 17px;
    right: 0px;
    width: 48px;
    height: 21px;
    color: #fff;
    font-size: 12px;
    text-align: center;
    border-radius: 50px 0px 0px 50px;
}
.emptyBox {
    img {
        width: 165px;
        height: 114px;
        margin-top: 40px;
    }
    >div {
        font-size: 13px;
        color: #9EA8BA;
        line-height: 19px;
    }
}
</style>